import type { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  description?: string
  action?: ReactNode
  children?: ReactNode
}

export function PageHeader({ title, description, action, children }: PageHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 md:gap-3 animate-fade-in">
      <div className="min-w-0 flex-1">
        <h1 className="page-title truncate">{title}</h1>
        {description && <p className="page-description line-clamp-1">{description}</p>}
      </div>
      <div className="flex items-center gap-2 md:gap-3 shrink-0">
        {children}
        {action}
      </div>
    </div>
  )
}
